// Fire on load event to prevent getting the banner height before the layout is done rendering
var fixedHeaderPaddingFn = function fixedHeaderPaddingFn() {
  var pagePaddingTop = $('.page').css('padding-top');
  // Only use the margin-top if it's a pixel value
  if (!pagePaddingTop || !pagePaddingTop.includes('px')) {
    clearInterval(headerResizeTimer);
    return;
  }
  pagePaddingTop = Number(pagePaddingTop.slice(0, -2));
  var fixedHeaderHeight = $('.fixed-header').height();

  // Only adjust the .page margin-top if the height difference is too big
  if (Math.abs(fixedHeaderHeight - pagePaddingTop) >= 2) {
    $('.page').css('padding-top', fixedHeaderHeight + 'px');
  }
};
try {
  var observer = new ResizeObserver(fixedHeaderPaddingFn);

  // Initialize the observer to watch for changes in the fixed header size
  observer.observe(document.querySelector('.fixed-header'));
} catch (e) {
  var _window$console;
  // ResizeObserver is not supported
  (_window$console = window.console) === null || _window$console === void 0 ? void 0 : _window$console.warn('ResizeObserver is not supported in this browser. Fixed header margin may not adjust correctly on resize.');

  // Set an interval to periodically check the header size
  var _headerResizeTimer = setInterval(fixedHeaderPaddingFn, 500);
  window.addEventListener('load', function () {
    clearInterval(_headerResizeTimer);
  });
}

// Also set an interval to check for changes in case ResizeObserver misses something
window.addEventListener('load', fixedHeaderPaddingFn);
module.exports = require('core/components/menu');